import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectTree from '@/components/SelectTree';
import { buildTeamTree } from '@/utils';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'TeamTree',
  components: {
    SelectTree: SelectTree
  },
  props: {
    // 接收绑定参数
    value: [String, Array],
    // 输入框宽度
    width: String,
    showCheckbox: {
      type: Boolean,
      default: false
    },
    // 是否可用
    disabled: {
      type: Boolean,
      default: false
    },
    singleChoose: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tempValue: this.value,
      options: [],
      defaultExpandedKeys: [],
      defaultProps: {
        value: 'teamCode',
        label: 'teamName',
        children: 'children'
      }
    };
  },
  computed: _objectSpread({}, mapGetters(['team'])),
  watch: {
    value: function value(val) {
      this.tempValue = val;
    },
    tempValue: function tempValue(val) {
      this.$emit('input', val);
    },
    teamId: function teamId() {
      this.init();
    },
    includeSub: function includeSub() {
      this.init();
    },
    includeSelf: function includeSelf() {
      this.init();
    }
  },
  created: function created() {
    this.init();
    if (this.value) {
      this.tempValue = this.value;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    securityTree: 'securityTree'
  })), {}, {
    init: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.getTeams();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    getTeams: function getTeams() {
      var _this = this;
      return new Promise(function (resolve) {
        _this.securityTree().then(function (response) {
          _this.$emit('export_original_tree_ary', response.data);
          _this.options = [_objectSpread(_objectSpread({}, _this.team), {}, {
            children: buildTeamTree(response.data, _this.team.teamCode)
          })];
          resolve(_this.options);
        });
        // this.options = [{ "teamId": null, "teamCode": "0000001", "teamName": "一汽解放" }, { "teamId": null, "teamCode": "0000001001", "teamName": "二级机构" }, { "teamId": null, "teamCode": "00000010010001", "teamName": "三级机构" }, { "teamId": null, "teamCode": "0000001002", "teamName": "顺丰货运" }, { "teamId": null, "teamCode": "0000001003", "teamName": "测试车队" }, { "teamId": null, "teamCode": "00000010030001", "teamName": "二级机构" }, { "teamId": null, "teamCode": "000000100300010001", "teamName": "三级机构" }, { "teamId": null, "teamCode": "0000001004", "teamName": "一汽解放汽车有限公司智慧物流分公司" }, { "teamId": null, "teamCode": "0000001005", "teamName": "郑州黑豹车队" }, { "teamId": null, "teamCode": "000000100300010003", "teamName": "专属车队" }, { "teamId": null, "teamCode": "0000001006", "teamName": "海城市大涛冷链运输有限公司" }, { "teamId": null, "teamCode": "00000010060001", "teamName": "XD统计" }, { "teamId": null, "teamCode": "0000001007", "teamName": "中石油运输有限公司云南分公司" }, { "teamId": null, "teamCode": "0000001008", "teamName": "福州运杰" }, { "teamId": null, "teamCode": "00000010070001", "teamName": "滇中配送中心" }, { "teamId": null, "teamCode": "00000010070002", "teamName": "滇南配送中心" }, { "teamId": null, "teamCode": "00000010070003", "teamName": "滇西配送中心" }, { "teamId": null, "teamCode": "00000010070004", "teamName": "滇东北配送中心" }, { "teamId": null, "teamCode": "00000010070005", "teamName": "滇东南配送中心" }, { "teamId": null, "teamCode": "00000010070006", "teamName": "航油配送中心" }, { "teamId": null, "teamCode": "0000001009", "teamName": "青岛质保" }, { "teamId": null, "teamCode": "00000010090001", "teamName": "李沧车队" }, { "teamId": null, "teamCode": "0000001010", "teamName": "安能物流" }, { "teamId": null, "teamCode": "00000010060002", "teamName": "海城市大涛冷链运输有限公司" }, { "teamId": null, "teamCode": "00000010040001", "teamName": "智慧物流三级车队" }, { "teamId": null, "teamCode": "00000010030002", "teamName": "顺丰-江西变形金刚车队" }, { "teamId": null, "teamCode": "0000001011", "teamName": "天地汇" }, { "teamId": null, "teamCode": "0000001012", "teamName": "一汽解放销售公司-要客部" }, { "teamId": null, "teamCode": "000000100300010004", "teamName": "测试机构" }, { "teamId": null, "teamCode": "0000001013", "teamName": "浙江金骏物流" }, { "teamId": null, "teamCode": "0000001014", "teamName": "金华腾邦汽车运输" }, { "teamId": null, "teamCode": "00000010120001", "teamName": "百世物流" }, { "teamId": null, "teamCode": "00000010120002", "teamName": "德邦物流" }, { "teamId": null, "teamCode": "00000010060003", "teamName": "平孚物流" }, { "teamId": null, "teamCode": "0000001015", "teamName": "江苏茂臻+淮安胜航" }, { "teamId": null, "teamCode": "0000001016", "teamName": "淮安胜航航运有限公司" }, { "teamId": null, "teamCode": "00000010150001", "teamName": "江苏茂臻贸易有限公司" }, { "teamId": null, "teamCode": "00000010150002", "teamName": "淮安胜航航运有限公司" }, { "teamId": null, "teamCode": "0000001017", "teamName": "数据验证" }, { "teamId": null, "teamCode": "0000001018", "teamName": "一汽解放销售公司" }, { "teamId": null, "teamCode": "0000001019", "teamName": "中石油运输车队" }, { "teamId": null, "teamCode": "0000001020", "teamName": "鱼快车队系统演示" }, { "teamId": null, "teamCode": "0000001021", "teamName": "轻卡顺丰" }, { "teamId": null, "teamCode": "0000001022", "teamName": "LY验证" }, { "teamId": null, "teamCode": "0000001023", "teamName": "顺丰-江西变形金刚车队" }, { "teamId": null, "teamCode": "0000001024", "teamName": "NJ验证" }, { "teamId": null, "teamCode": "0000001025", "teamName": "利航物流" }, { "teamId": null, "tea mCode": "0000001026", "teamName": "郑州坤通货运有限公司" }, { "teamId": null, "teamCode": "0000001027", "teamName": "北京中栋新能源技术有限公司" }, { "teamId": null, "teamCode": "00000010200001", "teamName": "NJ测试验证11" }, { "teamId": null, "teamCode": "00000010200002", "teamName": "大涛冷链演示" }, { "teamId": null, "teamCode": "00000010120003", "teamName": "邮政" }, { "teamId": null, "teamCode": "0000001028", "teamName": "北京路桥" }, { "teamId": null, "teamCode": "0000001029", "teamName": "解放年会-演示" }, { "teamId": null, "teamCode": "00000010200003", "teamName": "安徽天汇演示" }, { "teamId": null, "teamCode": "0000001030", "teamName": "momenta测试" }, { "teamId": null, "teamCode": "0000001031", "teamName": "天津昌易物流有限公司" }, { "teamId": null, "teamCode": "00000010200004", "teamName": "momenta测试" }, { "teamId": null, "teamCode": "00000010200005", "teamName": "北京中栋新能源演示" }, { "teamId": null, "teamCode": "0000001032", "teamName": "一汽物流（长春陆顺）储运有限公司" }, { "teamId": null, "teamCode": "0000001033", "teamName": "安徽天汇汽车销售服务有限公司" }, { "teamId": null, "teamCode": "0000001034", "teamName": "沭阳万联物流" }, { "teamId": null, "teamCode": "0000001035", "teamName": "大涛冷链测试" }, { "teamId": null, "teamCode": "0000001036", "teamName": "新绛县恒兴汽车运输有限公司" }, { "teamId": null, "teamCode": "0000001037", "teamName": "灵石县悦宏畅通运输有限公司" }, { "teamId": null, "teamCode": "0000001038", "teamName": "哈密盛嘉物流有限责任公司" }, { "teamId": null, "teamCode": "0000001039", "teamName": "轻卡综合部" }, { "teamId": null, "teamCode": "00000010040002", "teamName": "测试用的" }, { "teamId": null, "teamCode": "00000010040003", "teamName": "测试用的1" }, { "teamId": null, "teamCode": "00000010080001", "teamName": "测试用的2" }, { "teamId": null, "teamCode": "000000101500010001", "teamName": "十三点十分的" }, { "teamId": null, "teamCode": "00000010200007", "teamName": "NJ测试001" }, { "teamId": null, "teamCode": "00000010200008", "teamName": "NJ测试002" }, { "teamId": null, "teamCode": "000000102000010001", "teamName": "NJ测试验证22" }, { "teamId": null, "teamCode": "00000010020001", "teamName": "ca" }, { "teamId": null, "teamCode": "00000010020002", "teamName": "ca" }, { "teamId": null, "teamCode": "00000010020003", "teamName": "姜维物流总公司" }, { "teamId": null, "teamCode": "0000001044", "teamName": "测测测" }]
        // this.$emit('export_original_tree_ary', this.options)
        // team 当前登录人所在机构的id
        // this.options = [{ ... this.team, children: buildTeamTree(this.options, '0000001') }]
        // resolve(this.options)
      });
    }
  })
};